import React, { useEffect, useRef, useState } from "react";
import { apiCall } from "../../../../utils/axiosService";
import { API_URL } from "../../../../utils/apiRoutes";
import { apiResponse } from "../../../../utils/apiResponse";
import { useSelector } from "react-redux";
import { compName } from "../../../../utils/constant";
import WidgetDetailModal from "../../WidgetDetailModal";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import AddWidgetModal from "../../AddWidgetModal";
import Comments from "../Comments/Comment";
import { commonService } from "../../../../utils/commonService";
import Loader from "../../../Loader/Loader";
import DatePicker from "react-datepicker";
import {
    Button,
    Col,
    Form,
    Row,
} from "react-bootstrap";
import { Bar } from "react-chartjs-2";
import {
    Chart,
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend,
    PointElement,
    LineElement,
} from "chart.js";
Chart.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend,
    PointElement,
    LineElement
);


const DayOfWeekSegmentMix = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
}) => {
    const [marketSegmentData, setMarketSegmentData] = useState(null);
    const [showNoteSidebar, setShowNoteSidebar] = useState(false);
    const [widgetModal, setWidgetModal] = useState(false);
    const widgetDetailRef = useRef();
    const propertyDetailFromRTK = useSelector(
        (store) => store.headerProperty.propertyDetail
    );
    const closeWidgetModal = () => {
        setWidgetModal(false);
    };
    const closeNoteSideBar = () => {
        setShowNoteSidebar(false);
    };

    const [error, setError] = useState({
        dates: "",
    });

    const [StartDate, setStartDates] = useState(
        new Date().setDate(new Date().getDate() - 6)
    );
    const [EndDate, setEndDate] = useState(new Date());

    const handleStayDateChange = (dates) => {
        const [start, end] = dates;
        setStartDates(start);
        setEndDate(end ? end : "");
    };

    const DummyData = [
        {
            "weekday_name": "Sunday",
            "MarketSegment": "BRAND DISCOUNT",
            "reservation_count": "50",
            "percentage_share": "50",
            "total_revenue": "50",
            "adr": "50"
        },
        {
            "weekday_name": "Sunday",
            "MarketSegment": "DISCOUNT",
            "reservation_count": "50",
            "percentage_share": "50",
            "total_revenue": "50",
            "adr": "50"
        },
        {
            "weekday_name": "Monday",
            "MarketSegment": "BRAND DISCOUNT",
            "reservation_count": "50",
            "percentage_share": "50",
            "total_revenue": "50",
            "adr": "50"
        },
        {
            "weekday_name": "Monday",
            "MarketSegment": "DISCOUNT",
            "reservation_count": "50",
            "percentage_share": "50",
            "total_revenue": "50",
            "adr": "50"
        },
        {
            "weekday_name": "Tuesday",
            "MarketSegment": "BRAND DISCOUNT",
            "reservation_count": "50",
            "percentage_share": "50",
            "total_revenue": "50",
            "adr": "50"
        },
        {
            "weekday_name": "Tuesday",
            "MarketSegment": "DISCOUNT",
            "reservation_count": "50",
            "percentage_share": "50",
            "total_revenue": "50",
            "adr": "50"
        },
        {
            "weekday_name": "Wednesday",
            "MarketSegment": "BRAND DISCOUNT",
            "reservation_count": "50",
            "percentage_share": "50",
            "total_revenue": "50",
            "adr": "50"
        },
        {
            "weekday_name": "Wednesday",
            "MarketSegment": "DISCOUNT",
            "reservation_count": "50",
            "percentage_share": "50",
            "total_revenue": "50",
            "adr": "50"
        },
        {
            "weekday_name": "Thursday",
            "MarketSegment": "BRAND DISCOUNT",
            "reservation_count": "50",
            "percentage_share": "50",
            "total_revenue": "50",
            "adr": "50"
        },
        {
            "weekday_name": "Thursday",
            "MarketSegment": "DISCOUNT",
            "reservation_count": "50",
            "percentage_share": "50",
            "total_revenue": "50",
            "adr": "50"
        },
        {
            "weekday_name": "Friday",
            "MarketSegment": "BRAND DISCOUNT",
            "reservation_count": "50",
            "percentage_share": "50",
            "total_revenue": "50",
            "adr": "50"
        },
        {
            "weekday_name": "Friday",
            "MarketSegment": "DISCOUNT",
            "reservation_count": "50",
            "percentage_share": "50",
            "total_revenue": "50",
            "adr": "50"
        },
        {
            "weekday_name": "Saturday",
            "MarketSegment": "BRAND DISCOUNT",
            "reservation_count": "50",
            "percentage_share": "50",
            "total_revenue": "50",
            "adr": "50"
        },
        {
            "weekday_name": "Saturday",
            "MarketSegment": "DISCOUNT",
            "reservation_count": "50",
            "percentage_share": "50",
            "total_revenue": "50",
            "adr": "50"
        },
    ];
    const [loader, setloader] = useState(false);

    const DAY_OF_WEEK_SEGMENT_MIX = async () => {
        setloader(true)

        let marketSegmentResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.MARKET_SEGMENT.DAY_OF_WEEK_SEGMENT_MIX,
                body: {
                    startdate: commonService.getDateInDBFormat(StartDate),
                    enddate: commonService.getDateInDBFormat(EndDate),
                    propertyCode: para?.propertyCode,
                    asofdate: para?.asOfDate
                },
            },
            false
        );

        let response = apiResponse(false, marketSegmentResponse);

        if (response?.isValidate) {
            setMarketSegmentData(response.data.data);
        }
        else {
            setMarketSegmentData([]);
        }
        setloader(false);
    };

    useEffect(() => {
        if (api === 0) {
            setMarketSegmentData(DummyData)
        } else {
            if (para?.asOfDate)
                DAY_OF_WEEK_SEGMENT_MIX();
        }
    }, [para]);

    const [ChartData, setChartData] = useState(null);

    useEffect(() => {
        let lables = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        let objChart = {
            data: {
                labels: lables,
                datasets: [

                ],
            }
            , options: {
                plugins: {
                    title: {
                        display: false,
                    },
                    legend: {
                        display: true,
                        position: 'bottom',
                    },
                    tooltip: {
                        mode: 'index',
                        intersect: false,
                        callbacks: {
                            label: function (context) {
                                const dataset = context.dataset;
                                const label = dataset.label || '';
                                const value = context.formattedValue;
                                const index = context.dataIndex;
                                const data1Value = dataset.data1?.[index];
                                return `${label} : ${commonService.formateAmount(value)} (${commonService.formateAmount(data1Value)})`;
                            },
                        },
                    },
                },
                responsive: true,
                scales: {
                    x: {
                        stacked: true,

                    },
                    y: {
                        stacked: true,
                        /*max: 100,*/
                        ticks: {
                            callback: function (value) {
                                return commonService.getAmountInCompactFormat(value, true);
                            },
                        }, 
                    }
                }
            }
        }
        if (marketSegmentData) {
            if (marketSegmentData.length > 0) {
                const distinctSegments = [...new Set(marketSegmentData.map(item => item.MarketSegment))];
                if (distinctSegments && distinctSegments.length > 0) {
                    for (let m = 0; m < distinctSegments.length; m++) {
                        let msdata = {
                            label: distinctSegments[m],
                            data: [],
                            backgroundColor: commonService.CreateColor(distinctSegments[m]).BGColor,
                            data1: [],
                        };
                        for (let i = 0; i < lables.length; i++) {
                            let fd = marketSegmentData.filter((wd) => wd.weekday_name === lables[i] && wd.MarketSegment === distinctSegments[m]);
                            if (fd && fd.length > 0) {
                                if (fd[0].percentage_share)
                                    msdata.data.push(parseFloat(fd[0].total_revenue))
                                else
                                    msdata.data.push(0)

                                if (fd[0].reservation_count)
                                    msdata.data1.push(parseFloat(fd[0].adr))
                                else
                                    msdata.data1.push(0)
                            }
                            else {
                                msdata.data.push(0);
                                msdata.data1.push(0);
                            }
                        }
                        objChart.data.datasets.push(msdata);
                    }
                }
            }
        }

        setChartData(objChart);
    }, [marketSegmentData]);

    function fnApplySearch() {
        let datemessage = "";
        if (!StartDate || !EndDate) {
            datemessage = "Dates are required";
        }
        setError({
            dates: datemessage,
        });

        if (datemessage === "") {
            DAY_OF_WEEK_SEGMENT_MIX();
        }
    }

    return (
        <div className="widget-container">
            <Row>
                <div className="d-flex align-items-start gap-4 conditional-class mt-3">
                    <div className="no-border-break meghaDatePicker width225">
                        <Form.Label>Dates</Form.Label>
                        <DatePicker id={commonService.generateGlobalClickTrackerID("DayOfWeekSegmentMix", "dates", "")}
                            portalId="datepicker-root"
                            onChange={handleStayDateChange}
                            startDate={StartDate}
                            endDate={EndDate}
                            selectsRange
                            monthsShown={2}
                        />
                        {error?.dates && (
                            <small className="text-danger">{error?.dates}</small>
                        )}
                    </div>
                    <div className="marign-condition-btn">
                        <Button id={commonService.generateGlobalClickTrackerID("DayOfWeekSegmentMix", "apply", "")}
                            className="default-btn primary-btn gobtnwidth"
                            onClick={() => fnApplySearch()}>
                            Apply
                        </Button>
                    </div>
                </div>
            </Row>
            {api !== 0 && (
                <div className="gap-1 widget-container-menu">

                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("DayOfWeekSegmentMix", "info", "")}
                            src={infoIcon}
                            alt="info"
                            onClick={() => {
                                widgetDetailRef.current = {
                                    widgetdetails: "",
                                    usernote: "",
                                    compName: compName?.DayOfWeekSegmentMix,
                                    widgetId: para?.widgetId,
                                };
                                setWidgetModal(true);
                            }}
                        />
                    </Button>

                </div>
            )}
            <Row>
                <Col xl={12}>
                    {
                        loader ?
                            <Loader /> :
                            <>
                                {
                                    ChartData && ChartData.data &&
                                    <Bar data={ChartData.data} options={ChartData.options} />
                                }
                            </>
                    }

                </Col>
            </Row>
            {api !== 0 && <Comments widgetDetails={para} editorId={"DayOfWeekSegmentMix"} />}
            {showNoteSidebar && (
                <AddWidgetModal
                    showModal={showNoteSidebar}
                    closeModal={closeNoteSideBar}
                    widgetId={para?.widgetId}
                    propertyId={propertyDetailFromRTK?.propertyid}
                    rowTitle={para?.rowTitle}
                />
            )}
            {widgetModal && (
                <WidgetDetailModal
                    showModal={widgetModal}
                    closeModal={closeWidgetModal}
                    data={widgetDetailRef.current}
                />
            )}
        </div>
    );
};

export default DayOfWeekSegmentMix;
